import * as CodeMirror from 'codemirror';

import 'codemirror/mode/python/python.js';
import 'codemirror/mode/markdown/markdown.js';
import 'codemirror/mode/gfm/gfm.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/edit/closebrackets.js';
import 'codemirror/addon/mode/overlay.js';
import 'codemirror/addon/selection/active-line.js';
import 'codemirror/addon/hint/show-hint.js';
import 'codemirror/addon/search/match-highlighter.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/display/autorefresh.js';

import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/indent-fold.js';

window.CodeMirror = CodeMirror; // Required for angular-ui-codemirror, that checks for the global variable...